import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

export default function WeeklyLineChart({ data, dataKey, color }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={colors.grey[800]} />
        <XAxis
          dataKey="date"
          stroke={colors.grey[400]}
          style={{ fontSize: "12px" }}
        />
        <YAxis stroke={colors.grey[400]} style={{ fontSize: "12px" }} />
        <Tooltip
          contentStyle={{
            backgroundColor: colors.primary[500],
            border: `1px solid ${colors.grey[800]}`,
            borderRadius: "8px",
            color: colors.grey[100],
          }}
        />
        <Legend
          wrapperStyle={{ color: colors.grey[100], fontSize: "12px" }}
        />
        <Line
          type="monotone"
          dataKey={dataKey}
          stroke={color || colors.greenAccent[500]}
          strokeWidth={3}
          dot={{ fill: color || colors.greenAccent[500], r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}








